import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthData } from 'app/main/auth/auth-data.model';

export interface AppConfig {
  apiUrl: string
}

@Injectable()
export class AppConfigService {

  public config: AppConfig;

  constructor(private http: HttpClient) { }

  load(): Promise<any> {
    return this.http.get<AppConfig>("./assets/config.json")
      .toPromise()
      .then(
        data => {
          this.config = data;
        }
      )
  }

  loadLoginApps(): Promise<void> {
    return Promise.resolve().then(() => {
      if (document.URL.includes('login-apps')) {
        let url = new URL(document.URL);
        let authData = new AuthData();
        authData.token = url.searchParams.get('token');
        authData.tokenExpirationDate = new Date(url.searchParams.get('tokenExpirationDate'));
        localStorage.setItem('authData', JSON.stringify(authData));
        if (localStorage.getItem('authData')) {
          let redirectUrl = url.search.substring(url.search.indexOf('&redirectUrl=') + 13);
          document.location.replace(redirectUrl);
        }
      }
    })

  }

}
